import React from "react";
import { AuthProvider } from "./context/authContext";


function App() {
  return (
    <AuthProvider>
      <div className="App">
        
      </div>
    </AuthProvider>
  );
}

export default App;
